import "./index.scss";
import ScrollToTop from "react-scroll-to-top";
import { ReactComponent as GoToTop } from "../../assets/images/go-to-top.svg";
import { isMobile } from "react-device-detect";

function ScrollToTopComponent() {
  return (
    <ScrollToTop
      className={isMobile ? "ScrollToTopStyle-mobile" : "ScrollToTopStyle"}
      component={<GoToTop style={{ width: isMobile ? 20 : 24 }} />}
      smooth
      color="#6f00ff"
    />
  );
}

export default ScrollToTopComponent;
